import { c as _c } from "react/compiler-runtime";
import { BodyLong, Modal } from "@navikt/ds-react";
import { knappKlikket } from "@/common/analytics/events-and-properties/knappKlikket-properties";
import { FetchErrorAlert } from "@/ui/FetchErrorAlert";
import { TrackedButton } from "@/ui/TrackedButton";
import useSlettUtkastAction from "./useSlettUtkastAction";
interface Props {
  modalRef: React.RefObject<HTMLDialogElement | null>;
}
export function SlettUtkastModal(t0) {
  const $ = _c(21);
  const {
    modalRef
  } = t0;
  const {
    slettUtkastAction,
    isPendingSlettUtkast,
    error
  } = useSlettUtkastAction();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      heading: "Slett utkast",
      closeButton: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BodyLong>Er du sikker på at du vil slette utkastet ditt?</BodyLong>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== error) {
    t3 = <Modal.Body>{t2}<FetchErrorAlert error={error} fallbackMessage={"Noe gikk galt n\xE5r vi pr\xF8vde \xE5 slette utkastet. Vennligst pr\xF8v igjen\n            senere."} className="mt-4" /></Modal.Body>;
    $[2] = error;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== modalRef || $[5] !== slettUtkastAction) {
    t4 = () => slettUtkastAction({
      onSuccess: () => modalRef.current?.close()
    });
    $[4] = modalRef;
    $[5] = slettUtkastAction;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isPendingSlettUtkast) {
    t5 = <TrackedButton type="submit" variant="primary" loading={isPendingSlettUtkast} tracking={knappKlikket.oversiktSide.slettUtkastModal.bekreft}>Slett utkast</TrackedButton>;
    $[7] = isPendingSlettUtkast;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <form action={t4}>{t5}</form>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== modalRef) {
    t7 = <TrackedButton variant="secondary" onClick={() => {
      modalRef.current?.close();
    }} tracking={knappKlikket.oversiktSide.slettUtkastModal.avbryt}>Avbryt</TrackedButton>;
    $[12] = modalRef;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <Modal.Footer>{t6}{t7}</Modal.Footer>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== modalRef || $[18] !== t3 || $[19] !== t8) {
    t9 = <Modal ref={modalRef} header={t1} closeOnBackdropClick={true}>{t3}{t8}</Modal>;
    $[17] = modalRef;
    $[18] = t3;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}